import { isEmpty } from 'lodash';

import {
   PatientConsentDocumentAttachment,
   PatientConsentDocumentAttachmentQuery,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsSearch, useDataSyncing } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { FormContextValues } from '@dreryk/react-common';

import { AttachmentsFormBeanPart } from './PatientConsentDocumentAttachmentField';

const REFETCH_PATIENT_CONSENT_DOCUMENTS_ATTACHMENTS_INTERVAL_IN_MILLISECONDS = 5000;

type PatientConsentDocumentAttachmentFieldSynchronizationProps = Pick<
   FormContextValues<AttachmentsFormBeanPart>,
   'sync'
> & {
   readonly consentDocumentId: number;
};

export const PatientConsentDocumentAttachmentFieldSynchronization = (
   props: PatientConsentDocumentAttachmentFieldSynchronizationProps
): null => {
   const dataSyncing = useDataSyncing();

   useCqrsSearch<PatientConsentDocumentAttachment>(
      () => {
         const query = new PatientConsentDocumentAttachmentQuery();
         query.consentDocumentId = props.consentDocumentId;
         return query;
      },
      paginations.all(),
      {
         refetchInterval: REFETCH_PATIENT_CONSENT_DOCUMENTS_ATTACHMENTS_INTERVAL_IN_MILLISECONDS,
         enabled: !dataSyncing,
         onSuccess: (patientConsentDocumentAttachments) => {
            props.sync({
               attachments: isEmpty(patientConsentDocumentAttachments) ? null : patientConsentDocumentAttachments,
            });
         },
      }
   );

   return null;
};
